import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { addDomEvent } from '../events/add-dom-event.mjs';
import { Feature } from '../motion/features/Feature.mjs';
import { pipe } from '../utils/pipe.mjs';
var FocusGesture = /*#__PURE__*/function (_Feature) {
  function FocusGesture() {
    var _this;
    _classCallCheck(this, FocusGesture);
    _this = _callSuper(this, FocusGesture, arguments);
    _this.isActive = false;
    return _this;
  }
  _inherits(FocusGesture, _Feature);
  return _createClass(FocusGesture, [{
    key: "onFocus",
    value: function onFocus() {
      var isFocusVisible = false;
      /**
       * If this element doesn't match focus-visible then don't
       * apply whileHover. But, if matches throws that focus-visible
       * is not a valid selector then in that browser outline styles will be applied
       * to the element by default and we want to match that behaviour with whileFocus.
       */
      try {
        isFocusVisible = this.node.current.matches(":focus-visible");
      } catch (e) {
        isFocusVisible = true;
      }
      if (!isFocusVisible || !this.node.animationState) return;
      this.node.animationState.setActive("whileFocus", true);
      this.isActive = true;
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      if (!this.isActive || !this.node.animationState) return;
      this.node.animationState.setActive("whileFocus", false);
      this.isActive = false;
    }
  }, {
    key: "mount",
    value: function mount() {
      var _this2 = this;
      this.unmount = pipe(addDomEvent(this.node.current, "focus", function () {
        return _this2.onFocus();
      }), addDomEvent(this.node.current, "blur", function () {
        return _this2.onBlur();
      }));
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
}(Feature);
export { FocusGesture };